import type {
  BookingAnswerSnapshot,
  BookingAnswerValue,
  BookingDto,
} from './bookings.interface';

/** No angle brackets: Google descriptions and Brevo would swallow them as HTML. */
export const NOT_ANSWERED = '(not answered)';

export const CHECKBOXES_ANSWER_SEPARATOR = ', ';

const LEGACY_MESSAGE_ANSWER_LABEL = 'Message';

export interface BookingAnswerLine {
  label: string;
  text: string;
}

// A type alias, not an interface: Brevo params need an implicit index signature.
export type OwnerEmailAnswer = { label: string; value: string };

export function formatBookingAnswers(
  snapshot: BookingAnswerSnapshot[],
): BookingAnswerLine[] {
  return snapshot.map((answer) => ({
    label: answer.label,
    text: formatBookingAnswerValue(answer.value),
  }));
}

/** A booking without a snapshot shows its legacy message as the one answer. */
export function ownerEmailAnswers(
  booking: Pick<BookingDto, 'booking_answers' | 'customer_message'>,
): OwnerEmailAnswer[] {
  if (booking.booking_answers) {
    return formatBookingAnswers(booking.booking_answers).map(
      ({ label, text }) => ({ label, value: text }),
    );
  }
  return booking.customer_message
    ? [{ label: LEGACY_MESSAGE_ANSWER_LABEL, value: booking.customer_message }]
    : [];
}

function formatBookingAnswerValue(value: BookingAnswerValue): string {
  if (value === null || value.length === 0) return NOT_ANSWERED;
  if (Array.isArray(value)) return value.join(CHECKBOXES_ANSWER_SEPARATOR);
  return value;
}
